"use strict";

var _regeneratorRuntime = require("/Users/nightmail/Documents/SourceCode/codb.io/web/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/nightmail/Documents/SourceCode/codb.io/web/node_modules/@babel/runtime/helpers/asyncToGenerator");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var app_1 = __importDefault(require("firebase/app"));

var my_error_1 = __importDefault(require("../../models/my-error"));

var lodash_1 = __importDefault(require("lodash"));

function getGoogleCredentialByGoogleUser(googleUser) {
  var auth = googleUser.auth;
  var credential = app_1.default.auth.GoogleAuthProvider.credential(auth.idToken);
  return credential;
}

function getGoogleUserId(googleUser) {
  return googleUser.uid;
}

function _convertUser(user) {
  return lodash_1.default.pick(user, ['uid', 'displayName', 'email', 'emailVerified', 'isAnonymous', 'photoURL', 'providerData']);
}

function _checkIfGoogleUserRegisteredOnFirebase(googleUser, firebaseUser) {
  if (firebaseUser) {
    var googleUid = getGoogleUserId(googleUser);
    var providerData = firebaseUser.providerData;

    for (var i = 0; i < providerData.length; i++) {
      var singleProviderData = providerData[i];

      if (singleProviderData !== null && singleProviderData.providerId === app_1.default.auth.GoogleAuthProvider.PROVIDER_ID && singleProviderData.uid === googleUid) {
        return true;
      }
    }
  }

  return false;
}

function getUser() {
  return new Promise(function (resolve, reject) {
    var user = app_1.default.auth().currentUser;

    if (!!user) {
      resolve(user);
    } else {
      resolve(null);
    }
  });
}

exports.getUser = getUser;

function getUserId() {
  return _getUserId.apply(this, arguments);
}

function _getUserId() {
  _getUserId = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee() {
    var user;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getUser();

          case 2:
            user = _context.sent;
            return _context.abrupt("return", lodash_1.default.get(user, 'uid', ''));

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getUserId.apply(this, arguments);
}

exports.getUserId = getUserId;

function getUserIdSync() {
  var curUser = app_1.default.auth().currentUser;
  return lodash_1.default.get(curUser, 'uid', null);
}

exports.getUserIdSync = getUserIdSync;

function onAuthStateChanged(cb) {
  app_1.default.auth().onAuthStateChanged(function (user) {
    if (user) {
      var authInfo = _convertUser(user);

      var userId = authInfo.uid;
      cb(authInfo);
    } else {
      cb(null);
    }
  });
}

exports.onAuthStateChanged = onAuthStateChanged;

function getAuthInfo() {
  return new Promise(function (resolve, reject) {
    var unsubscribe = app_1.default.auth().onAuthStateChanged(function (curUser) {
      unsubscribe();

      if (curUser === null) {
        resolve(null);
      } else {
        var authInfo = _convertUser(curUser);

        resolve(authInfo);
      }
    });
  });
}

exports.getAuthInfo = getAuthInfo;

function createByGoogle(googleUser) {
  return new Promise(function (resolve, reject) {
    var unsubscribe = app_1.default.auth().onAuthStateChanged(function (curUser) {
      unsubscribe();

      if (!_checkIfGoogleUserRegisteredOnFirebase(googleUser, curUser)) {
        var credential = getGoogleCredentialByGoogleUser(googleUser);
        signInAndRetrieveDataWithCredential(credential).then(function (result) {
          resolve(result);
        });
      }
    });
  });
}

exports.createByGoogle = createByGoogle;

function signInAndRetrieveDataWithCredential(credential) {
  return app_1.default.auth().signInWithCredential(credential).then(function (userCredential) {
    var additionalUserInfo = userCredential.additionalUserInfo,
        user = userCredential.user;

    if (user) {
      var convertedUser = _convertUser(user);

      return convertedUser;
    } else {
      throw new Error("Failed to access 'user' which is supposed to be provided by Firebase");
    }
  });
}

exports.signInAndRetrieveDataWithCredential = signInAndRetrieveDataWithCredential;

function linkAndRetrieveDataWithCredential(credential) {
  var curUser = app_1.default.auth().currentUser;

  if (curUser === null) {
    throw new my_error_1.default('User not found');
  }

  return curUser.linkWithCredential(credential).then(function (userCredential) {
    var additionalUserInfo = userCredential.additionalUserInfo,
        user = userCredential.user;

    if (!user) {
      throw new my_error_1.default('User not found after link action');
    }

    var convertedUser = _convertUser(user);

    return convertedUser;
  });
}

exports.linkAndRetrieveDataWithCredential = linkAndRetrieveDataWithCredential;

function connectFacebook(token) {
  var credential = app_1.default.auth.FacebookAuthProvider.credential(token);
  return linkAndRetrieveDataWithCredential(credential);
}

exports.connectFacebook = connectFacebook;

function connectGoogle(googleUser) {
  return linkAndRetrieveDataWithCredential(getGoogleCredentialByGoogleUser(googleUser));
}

exports.connectGoogle = connectGoogle;

function createByFacebook(token) {
  return new Promise(function (resolve, reject) {
    var unsubscribe = app_1.default.auth().onAuthStateChanged(function (curUser) {
      unsubscribe();
      app_1.default.auth().setPersistence(app_1.default.auth.Auth.Persistence.LOCAL).then(function () {
        var credential = app_1.default.auth.FacebookAuthProvider.credential(token);
        signInAndRetrieveDataWithCredential(credential).then(function (remoteUser) {
          resolve(remoteUser);
        });
      });
    });
  });
}

exports.createByFacebook = createByFacebook;

function signInAnonymously() {
  return app_1.default.auth().signInAnonymously().then(function (userCredential) {
    if (userCredential && userCredential.user) {
      var user = userCredential.user;

      var convertedUser = _convertUser(user);

      return user;
    } else {
      throw new my_error_1.default('userCredential.user not found');
    }
  });
}

exports.signInAnonymously = signInAnonymously;

function signOut() {
  return app_1.default.auth().signOut();
}

exports.signOut = signOut;